module.exports = __webpack_public_path__ + "static/media/park.9096ee13.svg";